// ======================================================================
// File: src/modules/ppe/transport/pages/TransportDetailPage.jsx
// Module: PPE → Transport
// Purpose:
//   Workspace container for Transport Detail
//   Pattern aligned with FollowupDetailPage.jsx
// ======================================================================

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import transportService from "../services/transportService";
import TransportDetail from "../components/detail/TransportDetail";


// ======================================================================
// COMPONENT
// ======================================================================

export default function TransportDetailPage() {

  const { transportId } = useParams();

  const [loading, setLoading] = useState(true);
  const [transport, setTransport] = useState(null);

  // ------------------------------------------------------------------
  // LOAD TRANSPORT
  // ------------------------------------------------------------------
  const loadTransport = async () => {
    try {
      setLoading(true);

      const res = await transportService.getTransportById(
        transportId
      );

      setTransport(res.data);

    } catch (err) {
      console.error("Failed to load transport", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTransport();
  }, [transportId]);

  // ------------------------------------------------------------------
  // RENDER
  // ------------------------------------------------------------------
  if (loading) {
    return (
      <div className="p-4 text-center">
        Loading transport details...
      </div>
    );
  }

  if (!transport) {
    return (
      <div className="p-4 text-center text-danger">
        Transport not found
      </div>
    );
  }

  return (
    <TransportDetail
      transport={transport}
      reload={loadTransport}
    />
  );
}
